// set tag value to the element type (e.g. 'h1' or 'div')
export default {
    functional: true,

    props: {
        tag: {
            type: String,
            required: true,
        },
    },

    render(h, context) {
        return h(context.props.tag, context.data, context.children);
    },
};
